import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { Button, Row, Col, FormGroup, Input, Label } from 'reactstrap';
import LearnMoreModal from './LearnMoreModal';
import { UserTextOrNone } from './DisplayUserText';
import { StarRating, SuccessRating } from './DisplayRatings';
import { NONE_ENTERED } from './DisplayUserText';
import { extractActivityButtons } from '../../Views/ConstActivityBtns';
import { LABELS_FOR_SETUP, TEST_DRIVE_ACTIVITIES } from '../../Views/ConstForTestDriveSection';
import { ValuesList } from './ReviewRow';

TestDriveInfoTable.defaultProps = {
  showDetailsCol: false,
  showCompareCol: false,
  checkedState: null,
  onChange: null,
  showAddRemoveCol: false,
  onRemoveFromThisList: null,
  onAddToOtherList: null
}

export function TestDriveInfoTable(props){
  const {
    testDrives,
    activeTestDriveId='', //provide this if you want to mark the "current Test-drive"
    showDetailsCol, //T if you want a more button that shows details
    //props needed to show a compare checkbox
    showCompareCol,
    checkedState,
    onChange,
    //props need to add and remove items -- a little tricky as we want to use this for managing prospects as well as picks
    //(e.g., when displaying Prospects, pass in onAddPick and onRemoveProspect and, for now, do not show a Remove button)
    //(when displaying Picks, pass in onRemovePick, and do not show an Add button)
    showAddRemoveCol,
    showAddButton = true,
    showRemoveButton = true,
    onRemoveFromThisList,
    onAddToOtherList,

  } = props;

  if (testDrives && testDrives.length > 0){
    return(
      <>
      <TestDriveTableHeading showDetailsCol={showDetailsCol} showCompareCol={showCompareCol} showAddRemoveCol={showAddRemoveCol}/>
      {testDrives.map(function(testDrive, index) {
        let detailsHTML = showDetailsCol ? getDetailsTableHTML(testDrive) : "";      
        return(
          <TestDriveTableRow 
            key={index}
            isCurrentTestDrive={activeTestDriveId === testDrive.trialId}
            setupName={testDrive.setupName}
            name={testDrive.accessMethodName}
            starRating={testDrive.clientRating} 
            successRating={testDrive.practitionerRating}
            showDetailsCol={showDetailsCol}
            detailsHTML={detailsHTML}
            showCompareCol={showCompareCol}
            position={index}
            checkedState={checkedState}
            onChange={onChange}
            showAddRemoveCol={showAddRemoveCol}
            showAddButton={showAddButton}
            showRemoveButton={showRemoveButton}
            onRemoveFromThisList={onRemoveFromThisList}
            onAddToOtherList={onAddToOtherList}
          />
        );
      })}
      </>
    );
  }
  else return(<p>There are no Test-drives to display.</p>);
}

function TestDriveTableHeading(props){
  const {
    showDetailsCol, //T if you want a more button that shows details
    showCompareCol,  //T if you want a compare checkbox
    showAddRemoveCol //T if you want 2 buttons to add pick and remove prospect
  } = props;

  return(
    <Row>
      <Col>
        <strong>Access Method</strong>
      </Col>
      <Col>
        <strong>Rating</strong>
      </Col>
      <Col>
        <strong>Success</strong>
      </Col>
      {showDetailsCol
        ? <Col></Col>
        : <></>
      }
      {showCompareCol
        ? <Col></Col>
        : <></>
      }
      {showAddRemoveCol
        ? <Col></Col>
        : <></>
      }
    </Row>
  )
}

export function TestDriveTableRow(props){
  const{
    isCurrentTestDrive,
    setupName,
    name,
    starRating,
    successRating,
    showDetailsCol,
    detailsHTML,
    showCompareCol,
    position,
    checkedState,
    onChange,
    //props need to add picks and remove prospects
    showAddRemoveCol,
    showAddButton,
    showRemoveButton,
    onRemoveFromThisList,
    onAddToOtherList
  } = props;

  //pass in border='none' if you don't want border. otw you'll get border.
  const border = props.border || 'true';

  let cname = "aa-review-row aa-aligned-row";
  if(border !== 'none')
    cname = cname + " border-top";

  return(
    <Row className={cname}>
      <Col>
        <UserTextOrNone userText={setupName ? setupName : name} />
        <>
        { isCurrentTestDrive
          ?
          <>&nbsp;<span className="fa fa-circle" aria-hidden="true" style={{ color: 'green'}}></span></>          
          :
          null
        }
        </>
      </Col>
      <Col>
        <StarRating starRating={starRating} />
      </Col>
      <Col>
        <SuccessRating successRating={successRating} />
      </Col>
      {showDetailsCol
        ? <Col className="d-flex justify-content-center">
            <LearnMoreModal 
              linkText="more&gt;&gt;"
              title="Details for this Test-drive"
              content={detailsHTML}
            />
          </Col>
        : <></>
      }
      {showCompareCol
        ? <Col>
            <CompareCheckbox position={position} checkedState={checkedState} onChange={onChange} />
          </Col>
        : <></>
      }
      {showAddRemoveCol
        ? <Col>
            {(showAddButton && onAddToOtherList && onRemoveFromThisList)
              ? <div className="aa-stacked-button"><Button className="aa-inner-button" color="primary" onClick={() => {onAddToOtherList(position); onRemoveFromThisList(position)}}> Add to Picks </Button></div>
              : <></>
            }
            {(showRemoveButton && onRemoveFromThisList && onAddToOtherList)
              ? <div className="aa-stacked-button"><Button className="aa-inner-button" color="secondary" outline onClick={() => {onRemoveFromThisList(position); onAddToOtherList(position)}}> Revert to Prospects </Button></div>
              : <></>
            }
          </Col>
        : <></>
      }
    </Row>
  )
}

function CompareCheckbox(props){
  const{
    position,
    checkedState,
    onChange
  } = props;
  return(
  <FormGroup check key={position}>
    <Input
      id={`compare-ckbx-${position}`}
      value={`compare-ckbx-${position}`}
      checked={checkedState[position]}
      onChange={() => onChange(position)} 
      name={`compare-ckbx-${position}`}
      type="checkbox"
    />
    {' '}
    <Label for={`compare-ckbx-${position}`} check>
      Compare                  
    </Label>
  </FormGroup>
  );
}

//functions that provide HTML table markup to display the details of 1 or more Test-drives
//(You can pass in a single testDrive or an array of testDrives)
//(this is raw HTML, not a JSX component, so that it can be provided to LearnMoreModal as a string)

//TODO may want the LearnMoreModal to use JSX instead of HTML, but the problem there is it screws up raw HTML Vimeo embed code.
//https://stackoverflow.com/questions/33381029/react-how-to-pass-html-tags-in-props for info
export function getDetailsTableHTML(testDrives){
  //if only 1 testDrive passed in, convert that to an array
  testDrives = [].concat(testDrives);
  // testDrives = testDrives.concat(testDrives); //this is just to create a bunch to compare, for testing purposes.
  if(testDrives.length === 0){
    return("<p>There are no Test-drives selected, so there's nothing to compare.</p><p>To compare Test-drives, select 2 or more Test-drives to compare.</p>");
  }

  let colSpan = "" + (testDrives.length + 1);
  let priorityRow = getRowHTML('Priority activity', testDrives, 'priorityActivity');
  let nameRow = getRowHTML('Setup name', testDrives, 'setupName');
  let typeRow = getRowHTML('Type', testDrives, 'accessMethodName');
  let catRow = getRowHTML('Category', testDrives, 'accessMethodCategory');
  let selMethodRow = getRowHTML(LABELS_FOR_SETUP.SELECTION_METHOD, testDrives, 'setupSelectionMethod');
  let bodySiteRow = getRowHTML(LABELS_FOR_SETUP.BODY_SITES, testDrives, 'setupBodySite');
  let accessoriesRow = getRowHTML(LABELS_FOR_SETUP.ACCESSORIES, testDrives, 'setupAccessories');
  let posNotesRow = getRowHTML(LABELS_FOR_SETUP.POSITIONING, testDrives, 'setupPositioningNotes');
  let otherNotesRow = getRowHTML(LABELS_FOR_SETUP.OTHER, testDrives, 'setupOtherNotes');
  let activitiesRow = getRowHTML('Activities', testDrives, 'activities');
  let clientRatingRow = getRowHTML('Client rating', testDrives, 'clientRating');
  let clientFeedbackRow = getRowHTML('Client feedback', testDrives, 'clientFeedback');
  let practRatingRow = getRowHTML('Practitioner rating', testDrives, 'practitionerRating');
  let issuesNotedRow = getRowHTML('Issues noted', testDrives, 'issuesNoted');
  let practCommentsRow = getRowHTML('Practitioner comments', testDrives, 'practitionerComments');

  return(`
  <div>
  <table class="table aa-fixed-width">
    <tbody>
    ` +
      priorityRow +
    ` <tr>
        <th style="border-top-width: 1px; background-color: #CFE3DA;" colspan=` + colSpan + `>Access Method and Setup</th>
      </tr>
    ` + 
      nameRow + 
      typeRow + 
      catRow +
      selMethodRow +
      bodySiteRow +
      accessoriesRow +
      posNotesRow + 
      otherNotesRow +
      `
      <tr class="spacer"><td colspan=` + colSpan + `>&nbsp;</td></tr>
      <tr>
        <th style="background-color: #CFE3DA;" colspan=` + colSpan + `>Test-drive Results</th>
      </tr>
      ` + 
      activitiesRow + 
      clientRatingRow + 
      clientFeedbackRow +
      practRatingRow +
      issuesNotedRow +
      practCommentsRow +
      `
    </tbody>
  </table>
  </div>
  `
  );
}

function getRowHTML(headerTxt, testDrives, propertyName){
  // let value = testDrive[propertyName];
  const ACTIVITIES_PROPERTY = 'activities';
  const STAR_PROPERTY = 'clientRating';
  const SUCCESS_PROPERTY = 'practitionerRating';
  const PRIORITY_PROPERTY = 'priorityActivity';

  let cellMarkup = "";
  let i=0;
  for(i=0; i<testDrives.length; i++){
    //for most cells:
    let thisCell = getCellHTML(testDrives[i][propertyName]);
    //special cases. TODO Yes, this function has to know about the special cases. Any improvement possible?
    if(propertyName === ACTIVITIES_PROPERTY){
      let cellVal = getActivityStrings(testDrives[i][ACTIVITIES_PROPERTY]);
      thisCell = getCellHTML(cellVal);
    }
    if(propertyName === STAR_PROPERTY){
      thisCell = ReactDOMServer.renderToStaticMarkup(
        <StarRating starRating={testDrives[i][propertyName]} />
        );
    }
    if(propertyName === SUCCESS_PROPERTY){
      thisCell = ReactDOMServer.renderToStaticMarkup(
        <SuccessRating successRating={testDrives[i][propertyName]} />
        );
    }
    if(propertyName === PRIORITY_PROPERTY){
      let priority = testDrives[i][PRIORITY_PROPERTY];
      let activityBtns = extractActivityButtons();
      thisCell = ReactDOMServer.renderToStaticMarkup(
        <ValuesList 
        values={priority}
        lookup={activityBtns}
        asString={true}
      />);
    }
    cellMarkup = cellMarkup + `<td class="col">` + thisCell + `</td>`;
  }
  return(`
    <tr>
      <th scope="row" class="col">` + headerTxt + `</th>
      ` + cellMarkup + `
    </tr>
  `);

}

export function getActivityStrings(activities){
  let activityStrings = [];
  if (activities && activities.length > 0){
    activityStrings = activities.map((a, ix) => {
      return (getActivityString(a));
    });
  }
  return (activityStrings);
}

function getActivityString(a){  
  let aName = a.name || NONE_ENTERED;
  let aData = '';

  switch(a.type){
    case( TEST_DRIVE_ACTIVITIES.TEXT_ENTRY_BASIC):
      if(a.wpm){
        aData = "(" + a.wpm;
        if (a.accuracy){
          aData = aData + ', ' + a.accuracy + '%)';
        }
        else aData = aData + ")";
      }
      break;
    case( TEST_DRIVE_ACTIVITIES.POINTING_BASIC):
      if(a.targetsPerMinute){
        aData = "(" + a.targetsPerMinute;
        if (a.accuracy){
          aData = aData + ', ' + a.accuracy + '%)';
        }
        else aData = aData + ")";
      }
      break;
    case( TEST_DRIVE_ACTIVITIES.SWITCH_BASIC):
      if(a.duration){
        aData = "(" + a.duration + "s)";
      }    
      break;
    case( TEST_DRIVE_ACTIVITIES.OWN_ACTIVITY):
      if (aName === NONE_ENTERED){
        aName = 'Your own activity';
      }
      break;
    default:
      aData = '';
  }

  return(aName+' <span class="aa-more-info">'+aData+'</span>');
}

//incoming cellVal is either a string or an array of strings
function getCellHTML(cellVal){
  //check for empty array
  if(Array.isArray(cellVal))
    return(cellVal.length > 0 ? cellVal.join("<br/>") : NONE_ENTERED);
  //main case is for string values:
  return(cellVal || NONE_ENTERED);
}

